<app-tree emptyMessage="{{'admin.tools.details.detailsPage.labels.noEquipments' | translate}}"
          [loading]="loading"
          [isMaterial]="isMaterial"
          [items]="_items">
</app-tree>
